exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lazy-image-placeholder{background-position:50%;background-repeat:no-repeat;background-size:auto}.lazy-image{max-width:100%!important}.item_status{position:absolute;z-index:99999;right:0}.event-owner{font-weight:400;font-size:13px;line-height:15px;text-align:center;color:#000}.event-title{font-weight:400;font-size:14px;line-height:16px;color:#333;height:40px}.event-item{margin:0;padding:0;display:block;width:100%}.event-item:hover{box-shadow:0 5px 10px rgba(0,0,0,.1)!important}", ""]);

// exports
